import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { notify } from 'src/plugins/notify'
import routes from './routes'
// import store from '../store'

Vue.use(VueRouter)

const Router = new VueRouter({
  /*
   * NOTE! Change Vue Router mode from quasar.conf.js -> build -> vueRouterMode
   *
   * If you decide to go with "history" mode, please also set "build.publicPath"
   * to something other than an empty string.
   * Example: '/' instead of ''
   */

  // Leave as is and change from quasar.conf.js instead!
  mode: process.env.VUE_ROUTER_MODE,
  base: process.env.VUE_ROUTER_BASE,
  scrollBehavior: () => ({ y: 0 }),
  routes
})

Router.beforeEach(async (to, from, next) => {
  
    let path = to.path
    let menu = store.state.shared.navigationItems

    if(path == '/login' || path == '/attend' || path === '/forgotpassword') return next()

    let user = store.state.auth.user
    if(!user){
      await store.dispatch('auth/setCurrentUser')
      user = store.state.auth.user
    }

    /**
     * Yeah, this is bad, but have to get it done.
     */
    if(path == '/users'){
      let isInstructor = await store.dispatch('auth/$p', [['INSTRUCTOR']])
      let isOtherRoles =  await store.dispatch('auth/$p', [['ADMIN','AFFILIATE','MANAGER','RECRUITER'],'or'])
      if(isInstructor && !isOtherRoles ){
        next({path:'/students'})
      }
    }

    let match
    _.map(menu, ni => {
      if(ni.route == path) return match = ni
      if(ni.children){
        _.map(ni.children, c => {
          if(c.route == path) return match = c
        })
      }
    })

    if(!match){
      console.error("Couldnt find route configured: " + to.path)
      console.error(to)
      return next()
    }

    if(match && !match.$p){
      console.warn("No permissions set for: " + to.path)
      console.warn(to)
      return next()
    }

    if(match && match.$p){
      let $p = await store.dispatch('auth/$p', match.$p)
      if($p) return next()
    }
    else{
      // notify.create({message: "You don't have permission to this screen.", type: "negative"})
      return next()
    }
})

export default Router
